export default __webpack_public_path__ + "static/media/Pc8.b3180d25.jpg";